import Monitoring from '../views/Monitoring'
export default [
  {
    path: '/admin/monitoring',
    name: 'monitoring',
    component: Monitoring
  }
]
